<section class="home">
  <header class="home__header">
    <h1 class="home__title">Home Financials</h1>
    <p class="home__subtitle">Selecciona una sección para continuar</p>
  </header>

  <div class="home__grid">
    @for (card of homeCards; track card.title) {
    <a class="home__card-link" [routerLink]="[card.ruta]" [attr.aria-label]="'Ir a ' + card.title">
      <mat-card class="cardWithShadow card-hover home__card" matRipple>
        <mat-card-content class="home__card-content">
          <i-tabler class="home__icon" [attr.size]="'30'" name="{{ card.iconName }}"></i-tabler>
          <mat-card-title class="home__card-title">{{ card.title }}</mat-card-title>
        </mat-card-content>
      </mat-card>
    </a>
    }
  </div>

  <div class="home__new-module">
    <app-exchange-rate-card
      [data]="exchangeRateCardData"
      [isLoading]="isLoadingExchangeRate"
      [isEmpty]="isEmptyExchangeRate"
      (dateChange)="onExchangeDateChange($event)"
      (openMonthly)="onOpenMonthlyExchange()"
      (manage)="onManageExchange()"
    ></app-exchange-rate-card>
  </div>
</section>